"use strict";

import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.starts-with.js";
import { GRAPH_SERVICE_API } from '@autoguru/global-configs';
/**
 * Get allowed tracing URLs for DataDog RUM-APM correlation.
 *
 * This configuration enables automatic trace header injection for requests
 * to backend services, allowing correlation between frontend RUM traces
 * and backend APM traces.
 *
 * Supported propagator types:
 * - 'tracecontext': W3C Trace Context standard (recommended, future-proof)
 * - 'datadog': DataDog legacy x-datadog-* headers (backward compatibility)
 *
 * @returns Array of URL configurations for trace correlation
 */
export const getAllowedTracingUrls = () => {
  const urls = [];
  if (GRAPH_SERVICE_API) {
    urls.push({
      match: GRAPH_SERVICE_API,
      propagatorTypes: ['tracecontext', 'datadog']
    });
  } else if (process.env.NODE_ENV !== "production") {
    console.warn('[DataDog] GRAPH_SERVICE_API not defined - trace correlation disabled');
  }
  return urls;
};

/**
 * Check if a URL will have trace headers injected by DataDog RUM.
 *
 * Useful for debugging and testing trace correlation.
 *
 * @param url - The URL to check
 * @returns True if the URL matches allowedTracingUrls configuration
 */
export const isUrlTraced = url => {
  const allowedUrls = getAllowedTracingUrls();
  return allowedUrls.some(config => {
    if (typeof config === 'string') {
      return url.startsWith(config);
    }
    if (config instanceof RegExp) {
      return config.test(url);
    }
    if (typeof config === 'function') {
      return config(url);
    }
    if (typeof config === 'object' && config !== null && 'match' in config) {
      const {
        match
      } = config;
      if (typeof match === 'string') {
        return url.startsWith(match);
      }
      if (match instanceof RegExp) {
        return match.test(url);
      }
      if (typeof match === 'function') {
        return match(url);
      }
    }
    return false;
  });
};